import * as Material from "@mui/material";

import "./styles.css";

import { ReactComponent as BuildProductDraw } from "@assets/draws/product-creation.svg";
import AddIcon from "@mui/icons-material/Add";

import SettingsIcon from "@mui/icons-material/Settings";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

import "react-image-crop/dist/ReactCrop.css";

import Screen from "@components/Screen";

import { Button } from '@fragments'

import { useCommunity } from "contexts/community";
import { ArrowForwardIosRounded, ShareRounded } from "@mui/icons-material";

import CommunityCard from "./CommunityCard";
import { Text } from "@fragments"
import AICircle from "@components/AICircle";

export default function Communities() {
  document.title = "Comunidades | Ginastee";

  const { community } = useCommunity();

  window.communities = {};

  function handleOpenCreateNewCommunity() {
    community.management.open(null);
  }

  return (
    <>
      <Screen
        header={
          <>
            <div className="add-new-community-container">
              <h3>Suas Comunidades</h3>

              <Button
                color="white"
                onClick={handleOpenCreateNewCommunity}
                endIcon={<AddIcon />}
                text={"Criar nova comunidade"}
                className="create-new-community"
              />
            </div>
          </>
        }
      >
        <main className="communities-screen pb-8 ">
          <div className="communities-side">
            <CommunityList />
          </div>
        </main>
      </Screen>
    </>
  );
}

function CommunityList() {
  const { loading, communities, community } = useCommunity();

  const NoCommunities = ({ }) => {
    return (
      <div className="no-communities-box px-4 py-1">
        <div className="ai-circle-block">
          <AICircle size={70} />
        </div>
        <Text.h3 className="mt-2">Você ainda não está inscrito em nenhuma comunidade</Text.h3>
        <Text.h5 contrast={6} className="pb-2" style={{ width: '80%' }}>
          Crie sua própria comunidade com a I.A. Ginastee em menos de 5 minutos
        </Text.h5>
        <Button
          variant="contained"
          color="inverse"
          onClick={() => window.open('https://builder.ginastee.com')}
          endIcon={<AddIcon />}
          children="Criar nova comunidade"
        />
      </div>
    );
  };

  const communitiesDisplay = loading
    ? [{}, {}, {}, {}]
    : communities;


  return (<>
    <Text.h1 className="mt-5" weight={600}>Comunidades que você participa</Text.h1>
    <div className="mt-3 communities-container">
      {communitiesDisplay.map((item, index) => (
        <CommunityCard data={item} key={index} />
      ))}
      {!loading && !communities?.length && <NoCommunities />}
    </div>
  </>
  );
}
